import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'replace' })
export class ReplacePipe implements PipeTransform {
    transform(value: string, fields:any): string {
        if(!fields) return value;
        let _r = value;
        for (const key in fields) {
            const regex = new RegExp('@'+key+'@',"gi");
            _r = _r.replace(regex, fields[key]);
        }
        return _r;

    }
}